import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.element.addEventListener("trix-change", function(event) {
      // console.log("trix-change");
      event.target.form.requestSubmit();
    });
  }
}
